import { useMediaQuery } from '@intigral/hooks/dom/useMediaQuery/useMediaQuery';

export const PickNChooseHeaderBg = () => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    return isMobile ? (
        <svg width="375" height="594" viewBox="0 0 375 594" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                width="375"
                height="594"
                transform="matrix(-1 0 0 1 375 0)"
                fill="url(#paint0_radial_11681_170986)"
                fillOpacity="0.6"
            />
            <rect
                width="375"
                height="594"
                transform="matrix(-1 0 0 1 375 0)"
                fill="url(#paint1_radial_11681_170986)"
                fillOpacity="0.4"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_11681_170986"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(14.0625 34.65) scale(166.797 389.322)"
                >
                    <stop stopColor="#4F008C" />
                    <stop offset="1" stopColor="#4F008C" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_11681_170986"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="matrix(223.245 194.418 -35.801 325.992 342.187 102.3)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF375E" />
                    <stop offset="1" stopColor="#FF375E" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    ) : (
        <svg width="1212" height="654" viewBox="0 0 1212 654" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1212 0L0 0V654L1212 654V0Z" fill="url(#paint0_radial_11672_143128)" fillOpacity="0.6" />
            <path d="M1212 0L0 0V654L1212 654V0Z" fill="url(#paint1_radial_11672_143128)" fillOpacity="0.4" />
            <defs>
                <radialGradient
                    id="paint0_radial_11672_143128"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(1166.55 38.15) rotate(-180) scale(539.087 428.647)"
                >
                    <stop stopColor="#4F008C" />
                    <stop offset="1" stopColor="#4F008C" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_11672_143128"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="matrix(-721.528 214.056 115.709 358.92 106.05 112.633)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF375E" />
                    <stop offset="1" stopColor="#FF375E" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
};
